import { c as _c } from "react/compiler-runtime";
import { ProgressStepper } from "@justhome/react-ui";
import { useQualificationContext } from "@modules/booking/context/context";
const ProgressBar = () => {
  const $ = _c(9);
  const {
    totalSteps,
    currentStepIndex
  } = useQualificationContext();
  if (currentStepIndex === null || totalSteps <= 1 || totalSteps === currentStepIndex) {
    return null;
  }
  let t0;
  if ($[0] !== currentStepIndex || $[1] !== totalSteps) {
    t0 = <ProgressStepper steps={totalSteps} currentStep={currentStepIndex} initialPercentage={5} />;
    $[0] = currentStepIndex;
    $[1] = totalSteps;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = currentStepIndex + 1;
  let t2;
  if ($[3] !== t1 || $[4] !== totalSteps) {
    t2 = <span className="text-app-caption-1 text-neutral-675/60">Schritt {t1} von {totalSteps}</span>;
    $[3] = t1;
    $[4] = totalSteps;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t0 || $[7] !== t2) {
    t3 = <div className="mb-m">{t0}{t2}</div>;
    $[6] = t0;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default ProgressBar;